/** AppImage 스타일 — 부모를 채운다. 비율과 모서리는 담는 쪽(`Media` · `Avatar`)의 몫이다 */
import { cva } from "class-variance-authority";

export const appImageStyles = cva("size-full select-none", {
  variants: {
    resizeMode: { cover: "object-cover", contain: "object-contain" },
  },
  defaultVariants: { resizeMode: "cover" },
});
